import * as tslib_1 from "tslib";
import { DefaultMaterialManager } from "@awayjs/graphics";
import { GL_RenderableBase } from "./GL_RenderableBase";
/**
 * @class away.pool.GL_ShapeRenderable
 */
var GL_ShapeRenderable = (function (_super) {
    tslib_1.__extends(GL_ShapeRenderable, _super);
    /**
     * //TODO
     *
     * @param renderablePool
     * @param shape
     * @param level
     * @param indexOffset
     */
    function GL_ShapeRenderable(shape, renderablePool) {
        var _this = _super.call(this, shape, renderablePool) || this;
        _this.shape = shape;
        return _this;
    }
    GL_ShapeRenderable.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this.shape = null;
    };
    /**
     *
     * @returns {ElementsBase}
     * @protected
     */
    GL_ShapeRenderable.prototype._getElements = function () {
        this._offset = this.shape.offset;
        this._count = this.shape.count;
        return this._stage.getAbstraction((this.sourceEntity.animator) ? this.sourceEntity.animator.getRenderableElements(this, this.shape.elements) : this.shape.elements);
    };
    GL_ShapeRenderable.prototype._getMaterial = function () {
        return this._materialGroup.getMaterialPool(this.elementsGL).getAbstraction(this.shape.material || this.sourceEntity.material || DefaultMaterialManager.getDefaultMaterial(this.renderable));
    };
    return GL_ShapeRenderable;
}(GL_RenderableBase));
export { GL_ShapeRenderable };



// WEBPACK FOOTER //
// ../dist/lib/renderables/GL_ShapeRenderable.js